<div #dropdownContainer style="width: 100%;">
  <p-dropdown
    #dropdown
    [disabled]="isControlDisabled"
    [attr.aria-disabled]="isControlDisabled"
    [options]="options"
    [(ngModel)]="selectedItem"
    [optionLabel]="optionLabel"
    [ngClass]="{
      'hide-arrow': !showArrow,
      'hide-clear': !showClearButton
    }"
    (onShow)="setPanelWidth()"
    [appendTo]="appendToBody ? 'body' : undefined"
    [panelStyle]="{ width: panelWidth + 'px' }"
    [panelStyleClass]="setPanelHeight ? 'dropdown-scroll-limit' : undefined"
    [checkmark]="true"
    [showClear]="true"
    (onChange)="onSelectionChange($event.value)"
    [placeholder]="placeholder"
    (onFocus)="onFocus()"
    (onBlur)="onBlur()"
    appendTo="body"
    [style.cursor]="isControlDisabled ? 'not-allowed' : 'pointer'">
  </p-dropdown>
</div>
<div aria-live="assertive" class="sr-only">
  {{ariaMessage}}
</div>
